module.exports = __webpack_public_path__ + "static/media/project12.820eca53.jpg";